module.exports = {
  'account.footer.copyright': '© 2018 - 2019 Binance.org. Все права защищены.',
  'account.footer.copyright.trubi': '© 2018 - 2019 Trubi. Все права защищены.',
  'account.footer.exchange': 'Биржа',
  'account.footer.home': 'Главная',
  'balances.filteredByAsset': 'Отфильтровано по активам',
  'balances.hideZeroBalance': 'Скрыть нулевой баланс',
  'balances.myBalances': 'Мои балансы',
  'blocked.country.list':
    "Соединенные Штаты Америки, Албания, Босния и Герцеговина, Республика Беларусь, Конго (ДРК), Кот-д'Ивуар, Крым, Куба, Ирак, Иран, Северная Корея, Либерия, Македония, Мьянма, Сербия, Судан, Сирия, Зимбабве.",
  'common.cancel': 'Отменить',
  'common.close': 'Закрыть',
  'common.confirm': 'Подтвердить ',
  'common.connect': 'Подключить',
  'common.continue': 'Продолжить',
  'common.errorOccured': 'произошла ошибка',
  'common.goBack': 'Вернуться назад',
  'common.googleUnlock': 'Google Drive',
  'common.keystoreFile': 'Файл Keystore',
  'common.ledgerDevice': 'Ledger',
  'common.loading': 'Загрузка',
  'common.mnemonicPhrase': 'Фраза восстановления',
  'common.networkError': 'Ошибка сети',
  'common.or': 'или',
  'common.password': 'Пароль',
  'common.placeOrder': 'Разместить ордер',
  'common.pleaseCheckVisitWebsite': 'Пожалуйста, убедитесь, что вы заходите на ',
  'common.previous': 'Предыдущий',
  'common.privateKey': 'Приватный Ключ',
  'common.systemError': 'Системная ошибка',
  'common.trezorDevice': 'Устройство Trezor',
  'common.viewMyPrivateKey': 'Просмотреть мой приватный ключ',
  'common.viewOnly': 'Только просмотр',
  'common.walletConnect': 'Мобильный кошелек',
  'common.yes': 'Да',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': 'Резервное копирование вашего ',
  'create.backupKeystore.cannotRecoveredIt':
    'Он не может быть восстановлен, если вы его потеряете.',
  'create.backupKeystore.createBackupFile': 'Создать резервную копию этого файла!',
  'create.backupKeystore.downloadKeystoreFile': 'Скачать Keystore File (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': 'Получить мой приватный ключ',
  'create.backupKeystore.keystoreFile': 'Файл Keystore',
  'create.backupKeystore.needFirstDownload': 'Сначала Вам необходимо скачать Keystore File',
  'create.backupKeystore.notShareFile':
    'Не делитесь и не используйте данный файл на непроверенных веб-сайтах. Возможно, ваши средства могут быть украдены.',
  'create.backupMnemonic.note':
    'Сделайте резервную копию представленного ниже текста на бумаге и храните данную копию в секретном и в безопасном месте.',
  'create.backupMnemonic.title': 'Пожалуйста, сделайте резервную копию мнемонической',
  'create.backupText':
    'Сделайте резервную копию представленного ниже текста на бумаге и храните данную копию в секретном и в безопасном месте.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': 'Keystore File + Пароль',
  'create.chooseKSOrMnemonic.keystoreFile': 'Файл Keystore',
  'create.chooseKSOrMnemonic.recommendedUSBDrive':
    'Рекомендуется сделать резервную копию на USB-накопителе',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    'Рекомендуется сделать резервную копию на бумаге или USB-накопителе',
  'create.chooseKSOrMnemonic.title': 'Как вы хотите создать свой новый кошелек?',
  'create.chooseKSOrMnemonic.unlockExistWallet': 'Открыть существующий кошелек',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    'Используйте файл Keystore (UTC / JSON) + Пароль для получения доступа к вашему кошельку',
  'create.chooseKSOrMnemonic.useMnemonicPhrase':
    'Используйте вашу Мнемоническую фразу из 24-х слов для получения доступа к вашему кошельку',
  'create.confirmNote': 'Вы уверены, что записали свою мнемоническую фразу?',
  'create.createNewWallet': 'Создать новый кошелек',
  'create.doubleConfirmMnemonic.note':
    'Чтобы убедиться, что Ваша копия верна, пожалуйста, введите мнемоническую фразу в правильном порядке.',
  'create.doubleConfirmMnemonic.title': 'Выберите вторичный доступ',
  'create.doubleConfirmMnemonic.tryAgain':
    'Мнемоническая фраза указана в неверном порядке. Пожалуйста, попробуйте еще раз.',
  'create.downloadKeyStoreFile': 'Загрузить файл Keystore',
  'create.enterPassword': 'Введите пароль',
  'create.google.createWallet': 'Создать кошелек',
  'create.google.createdSuccessfully': 'Кошелек успешно создан',
  'create.google.creationFailure': 'Ошибка создания кошелька',
  'create.google.tryAgain': 'Попробовать снова',
  'create.google.walletName': 'Название кошелька',
  'create.googledrive.rePassErr': 'Введенный пароль не совпадает',
  'create.keystoreFileAndPassword': 'Создать Keystore File + Пароль',
  'create.pick.useGoogleDrive.description': 'Создать новый кошелек, используя свой аккаунт Google',
  'create.pick.useGoogleDrive.title': 'Используя Google Drive',
  'create.pick.useLocalKeystore.description':
    'Создайте новый кошелек, который вы можете хранить на своем устройстве',
  'create.pick.useLocalKeystore.title': 'Используя Keystore-Файл',
  'create.pleaseCheck': 'Пожалуйста, убедитесь, что вы заходите на ',
  'create.reEnterPassword': 'Повторно введите пароль',
  'create.stepTwo.desc':
    'Мы собираемся показать вашу мнемоническую фразу, пожалуйста, убедитесь, что никто не смотрит на ваш экран.',
  'create.success.desc1': 'Вы готовы к использованию кошелька Binance Chain и',
  'create.success.desc2': 'Децентрализированная биржа!',
  'create.success.title': 'Всё готово!',
  'create.success.unlockWallet': 'Разблокировать кошелек',
  'create.tutorial.next': 'Далее',
  'create.tutorial.skip': 'Пропустить обучение (не рекомендуется)',
  'create.tutorial.step1.desc1':
    'Binance стремится предоставить вам самый лучший и безопасный опыт в Binance Chain. Для этого мы хотели бы попросить минуту вашего времени, чтобы вы могли понять, как работают децентрализованные кошельки и принять дальнейшие меры для того, чтобы обезопасить себя. Найти полные Условия Использования вы можете здесь.',
  'create.tutorial.step1.title': 'Наши обязательства',
  'create.tutorial.step2.desc1':
    'Вы несете полную ответственность за сохранение своих средств. Никто другой, включая Binance, не сможет помочь вам восстановить свой кошелек, если вы его потеряете.',
  'create.tutorial.step2.desc2':
    'Когда вы создаете кошелек на Binance, вам предоставляется 3 различных формата, каждый из которых может быть использован для получения доступа к вашему кошельку.',
  'create.tutorial.step2.title': 'Сохранение Ваших Средств',
  'create.tutorial.step3.desc1':
    'Вы можете думать о keystore-файле как об «Идентификаторе пользователя», в то время как пароль открывает ваш кошелек. Оба необходимы для доступа к вашему кошельку, так что держите их в безопасности. Это обязательный формат на Binance.',
  'create.tutorial.step3.title': 'Keystore File + Пароль',
  'create.tutorial.step4.desc1':
    '24 слова являются одновременно и «идентификатором пользователя», и паролем. Это вторичный способ получить доступ к вашему кошельку, если вы потеряете keystore-файл или забудете свой пароль. Любой, кто узнает вашу мнемоническую фразу, сможет получить доступ к вашему кошельку, поэтому рекомендуем держать данную фразу в безопасности.',
  'create.tutorial.step4.title': 'Мнемоническая фраза',
  'create.tutorial.step5.desc1': 'Это альтернативное представление слов мнемонической фазы.',
  'create.tutorial.step5.desc2':
    'Binance требует от всех пользователей использовать keystore-файл и пароль; в качестве вторичного метода вам необходимо выбрать между использованием мнемонической фразы или приватного ключа.',
  'create.tutorial.step5.title': 'Приватный ключ',
  'create.tutorial.title': 'Руководство по созданию кошелька',
  'create.tutorial.understand': 'Я понимаю',
  'create.understandCheckbox':
    'Я понимаю, что Binance не сможет восстановить или сбросить мой пароль или keystore файл. Я сделаю резервную копию keystore-файла / пароля, сохраню их в надежном месте, выполню все шаги по созданию кошелька и согласен со всеми ',
  'create.understandCheckbox.terms': 'условия',
  'create.unlockExistWallet': 'Открыть существующий кошелек',
  'create.yourKeyStore': 'Ваш Keystore',
  'editWallet.remove': 'Удалить',
  'editWallet.remove.desc1': 'Пожалуйста, убедитесь, что на кошельке нет денег',
  'editWallet.remove.desc2': ', так как нет способа восстановить кошелек',
  'editWallet.remove.removeButton': 'Да, удалить этот кошелек',
  'editWallet.remove.title': 'Вы действительно хотите удалить этот кошелек?',
  'editWallet.rename': 'Переименовать',
  'editWallet.rename.duplicateName': 'Кошелек с таким именем уже существует',
  'editWallet.rename.errMsg': 'Имя не может отсутствовать',
  'editWallet.rename.title': 'Название кошелька',
  'editWallet.title': 'Название кошелька',
  'editWallet.createWallet': 'Создать кошелек',
  'editWallet.unlockWallet': 'Разблокировать кошелек',
  'exchange.BTCValue': 'Стоимость в BTC',
  'exchange.amount': 'Сумма',
  'exchange.asset': 'Актив',
  'exchange.availableBalance': 'Доступный баланс',
  'exchange.blockHeight': 'Высота блока',
  'exchange.buy': 'Купить',
  'exchange.calendar.clear': 'Очистить',
  'exchange.calendar.ok': 'Ок',
  'exchange.calendar.today': 'Сегодня',
  'exchange.chartbox.depth': 'Глубина',
  'exchange.coin': 'Криптовалюта',
  'exchange.date': 'Дата',
  'exchange.estimatedValue': 'Ориентировочная стоимость',
  'exchange.filled': 'Заполнено',
  'exchange.from': 'От',
  'exchange.frozen': 'Заморожено',
  'exchange.hideAllCanceled': 'Скрыть все отмененные',
  'exchange.hideOtherPairs': 'Скрыть остальные пары',
  'exchange.inOrder': 'В ордерах',
  'exchange.index.books': 'Книга ордеров',
  'exchange.index.chart': 'Диаграмма',
  'exchange.max': 'Макс',
  'exchange.min': 'Минимальная торговая единица:',
  'exchange.name': 'Название',
  'exchange.notional': 'Условная сумма',
  'exchange.oneDay': '1 день',
  'exchange.oneMonth': '1 месяц',
  'exchange.oneWeek': '1 неделя',
  'exchange.pair': 'Пара',
  'exchange.placeOrder.bestAsk': 'Лучшее предложение',
  'exchange.placeOrder.bestBid': 'Лучший спрос',
  'exchange.placeOrder.limitOrder': 'Лимит ордер',
  'exchange.placeOrder.noEnoughBalance': 'недостаточно баланса',
  'exchange.placeOrder.orderError': 'Ошибка ордера',
  'exchange.placeOrder.orderPriceHigher':
    'Стоимость вашего ордера будет на 2% выше, чем последняя рыночная цена. Пожалуйста, будьте осторожны.',
  'exchange.placeOrder.orderPriceLow':
    'Стоимость вашего ордера будет на 2% ниже, чем последняя рыночная цена. Пожалуйста, будьте осторожны.',
  'exchange.placeOrder.pleaseInputCorrectAmount': 'пожалуйста, введите правильную сумму',
  'exchange.placeOrder.pleaseInputCorrectPrice': 'пожалуйста, введите правильную стоимость',
  'exchange.placeOrder.roundSizeErrorMsg':
    'Вы можете использовать только {side} {baseAsset}, кратную {lotSize}',
  'exchange.placeOrder.successNotifyMsg':
    'Вы успешно создали лимит ордер для {side} {quantity} {quoteAsset}',
  'exchange.placeOrder.successNotifyTitle': 'Лимит{side} ордер создан',
  'exchange.pleaseSelectDate': 'пожалуйста, выберите дату',
  'exchange.pleaseUnlockWallet.btn': 'Разблокировать кошелек',
  'exchange.pleaseUnlockWallet.createNewWallet': 'Создать новый кошелек',
  'exchange.pleaseUnlockWallet.desc': 'Упс! Пожалуйста, разблокируйте сначала свой кошелек',
  'exchange.pleaseUnlockWallet.noWallet': 'Нет кошелька?',
  'exchange.price': 'Цена',
  'exchange.search': 'Поиск',
  'exchange.sell': 'Продать',
  'exchange.side': 'Сторона',
  'exchange.status': 'Статус',
  'exchange.symbolPriceInfo.high': 'Макс',
  'exchange.symbolPriceInfo.lastPrice': 'Последняя цена',
  'exchange.symbolPriceInfo.low': 'Мин',
  'exchange.symbolPriceInfo.twentyFourHChange': 'Изменение за 24ч',
  'exchange.symbolPriceInfo.twentyFourHHigh': 'Макс за 24ч',
  'exchange.symbolPriceInfo.twentyFourHLow': 'Мин за 24ч',
  'exchange.symbolPriceInfo.twentyFourHVolume': 'Объем торгов за 24ч',
  'exchange.symbolPriceInfo.vol': 'Объем',
  'exchange.threeMonths': '3 месяца',
  'exchange.time.from': 'От',
  'exchange.to': 'До',
  'exchange.total': 'Итого',
  'exchange.totalBalance': 'Общий баланс',
  'exchange.tradingHistory.time': 'Время',
  'exchange.tradingHistory.title': 'История сделок',
  'exchange.tradingPair.change': 'Изменение',
  'exchange.tradingPair.pair': 'Пара',
  'exchange.tradingPair.price': 'Цена',
  'exchange.tradingPair.search': 'Поиск',
  'exchange.tradingPair.volume': 'Объем',
  'exchange.txFee': 'TxFee',
  'exchange.txHash': 'Хэш транзакции',
  'exchange.type': 'Тип',
  'exchange.value': 'Стоимость',
  'fees.fee': 'Комиссия',
  'fees.height': 'Высота',
  'fees.note': 'Примечание',
  'footer.terms': 'Условия использования',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': 'Имя занято',
  'header.balances': 'Балансы',
  'header.createWallet': 'Создать кошелек',
  'header.exchange': 'Биржа',
  'header.explorer': 'Обозреватель',
  'header.faq': 'Документация / FAQ',
  'header.feeHistory': 'История комиссий',
  'header.forums': 'Форумы',
  'header.mainnet': 'Маиннет',
  'header.openOrders': 'Открытые ордера',
  'header.orderHistory': 'История ордеров',
  'header.orders': 'Ордера',
  'header.testnet': 'тестнет',
  'header.tradeHistory': 'История сделок',
  'header.transactions': 'Транзакции',
  'header.unlockWallet': 'Разблокировать кошелек',
  'header.user.changeWallet': 'Сменить кошелек',
  'header.user.closeWallet': 'Закрыть кошелек',
  'header.user.coinomi': 'Coinomi ',
  'header.user.copyAddress': 'скопировать адрес',
  'header.user.copySuccess': 'Скопировано успешно!',
  'header.user.createNewWallet': 'Создать новый кошелек',
  'header.user.exportKeystoreFile': 'Экспорт Keystore-Файла',
  'header.user.goToExplorer': 'перейти к обозревателю',
  'header.user.infinito': 'Infinito ',
  'header.user.ledger': 'Ledger ',
  'header.user.trezor': 'Устройство Trezor',
  'header.user.wallet': 'Кошелек',
  'header.user.walletConnect': 'WalletConnect ',
  'header.youWantCloseWallet': 'Вы уверены, что хотите закрыть кошелек?',
  'home.aboutPage.desc1.line1':
    'Binance Chain - это блокчейн, изначально разработанный командой Binance.',
  'home.aboutPage.desc1.line2':
    'Это современно, безопасно и почти мгновенно исполняет транзакции (это быстро).',
  'home.aboutPage.desc2.line1':
    'Binance DEX - это децентрализованный механизм сопоставления ордеров,',
  'home.aboutPage.desc2.line2': 'работающий на базе технологии Binance Chain.',
  'home.aboutPage.desc3.line1': 'Binance DEX является современным и безопасным рынком для выпуска',
  'home.aboutPage.desc3.line2':
    'и обмена цифровых активов, и никто, кроме вас, не владеет вашими ключами. Торговля любимыми активами никогда не была более безопасной.',
  'home.aboutPage.title': 'О Binance DEX',
  'home.binanceDex': 'Binance DEX',
  'home.processPage.aboutBalance': 'О Binance DEX',
  'home.processPage.create': 'Создать',
  'home.processPage.createDesc': 'Во-первых, необходимо создать адрес Binance Chain.',
  'home.processPage.createWallet': 'Создать новый кошелек',
  'home.processPage.getStart': 'Начать с Binance DEX',
  'home.processPage.go': 'Вперед',
  'home.processPage.placeOrders': 'Разместить ордера',
  'home.processPage.placeOrdersDesc':
    'Используйте веб-кошелек или API для отправки и отмены ордеров.',
  'home.processPage.transferAssets': 'Перевести активы',
  'home.processPage.transferAssetsDesc':
    'С помощью адреса Binance Chain, который может быть сгенерирован любым кошельком, поддерживающим Binance Chain, вы можете перевести BNB или другие активы, хранящиеся на данном адресе.',
  'home.processPage.unlock': 'Разблокировать',
  'home.processPage.unlockDesc': 'Четыре способа разблокировки кошелька',
  'home.processPage.unlockMode1': 'WalletConnect',
  'home.processPage.unlockMode2': 'Ledger',
  'home.processPage.unlockMode3': 'Keystore File + Пароль',
  'home.processPage.unlockMode4': 'Мнемоническая фраза',
  'home.processPage.unlockWallet': 'Разблокировать кошелек',
  'home.startPage.createWallet': 'Создать кошелек',
  'home.startPage.desc1': 'Быстрый и безопасный децентрализованный обмен цифровыми активами',
  'home.startPage.desc2': 'Новый стандарт торговли криптовалютами.',
  'home.startPage.getTestBNB': 'Получить тестовые BNB',
  'home.startPage.startTrading': 'Начать торговлю',
  'home.whyPage.community': 'Это инициатива сообщества',
  'home.whyPage.communityDesc':
    'Биржа Binance DEX основана на режиме управления On-Chain и программных компонентах с открытым исходным кодом.',
  'home.whyPage.decentralized': 'Децентрализованно',
  'home.whyPage.decentralizedDesc':
    'Опыт торговли напрямую с кошелька, без участия третьей стороны или центрального органа.',
  'home.whyPage.getStarted': 'Начать',
  'home.whyPage.lowTradingFees': 'Низкие торговые комиссии',
  'home.whyPage.lowTradingFeesDesc':
    'Торгуйте без комиссий за снятие и внесение средств или размещение ордеров - держатели BNB получают гораздо больше преимуществ.',
  'home.whyPage.safeAndSecure': 'Безопасно и надежно',
  'home.whyPage.safeAndSecureDesc':
    'Ваши средства хранятся на блокчейне с приватным ключом, который контролируете только вы.',
  'home.whyPage.title': 'Почему Binance DEX',
  'home.whyPage.userFriendly': 'Удобен для пользователей',
  'home.whyPage.userFriendlyDesc':
    'Создайте и разблокируйте свой кошелек и вы готовы начать торговлю. Нет необходимости вводить или выводить средства.',
  'inputPassword.passwordRule': 'Ваш пароль должен соответствовать следующим условиям',
  'inputPassword.passwordRule1': '8 или более символов',
  'inputPassword.passwordRule2': 'Заглавная буква, символ и число',
  'inputPassword.setANewPassword': 'Установить новый пароль',
  'landing.connectWallet': 'Подключить кошелек',
  'landing.createWallet': 'Создать кошелек',
  'landing.desc1': 'Binance DEX',
  'landing.desc2':
    'Быстрая и безопасная децентрализованный биржа для обмена цифровых активов. Здесь новый стандарт торговли криптовалютой.',
  'landing.footer.fee': 'Комиссия',
  'landing.footer.terms': 'Условия использования',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': 'Подключить',
  'landing.how.connect.desc':
    'Использование Binance DEX намного проще, чем вы думаете. Нажмите на кнопку подключения и выберите один из появившихся вариантов. Всё готово.',
  'landing.how.create': 'Создать',
  'landing.how.create.desc':
    'Binance DEX дает вам свободу выбора между удобными хранилищами ключей и ультра-безопасными вариантами аппаратных кошельков.',
  'landing.how.step': 'шаг',
  'landing.how.title': 'Как использовать',
  'landing.how.trade': 'Торговля',
  'landing.how.trade.desc':
    'Наша цель - сделать торговлю плавной и неотличимой от Binance.com. Для этого мы оптимизировали лучшие функции, чтобы все, что вы любите, было и на Binance DEX.',
  'landing.markets': 'Рынки',
  'landing.markets.24HChange': 'Изменение за 24ч',
  'landing.markets.24HVolume': 'Объем торгов за 24ч',
  'landing.markets.lastPrice': 'Последняя цена',
  'landing.markets.pair': 'Пара',
  'landing.markets.searchPlaceholder': 'Искать название монеты',
  'landing.menu.balances': 'Балансы',
  'landing.menu.changeWallet': 'Сменить кошелек',
  'landing.menu.closeWallet': 'Закрыть кошелек',
  'landing.menu.community': 'Сообщество',
  'landing.menu.copyAddress': 'скопировать адрес',
  'landing.menu.docs': 'Документы',
  'landing.menu.exchange': 'Биржа',
  'landing.menu.explorer': 'Обозреватель',
  'landing.menu.orders': 'Ордера',
  'landing.menu.orders.feeHistory': 'История комиссии',
  'landing.menu.orders.openOrders': 'Открытые ордера',
  'landing.menu.orders.orderHistory': 'История ордеров',
  'landing.menu.orders.tradeHistory': 'История сделок',
  'landing.menu.testnet': 'Тестнет',
  'landing.menu.tools': 'Инструменты',
  'landing.menu.transaction': 'Транзакция',
  'landing.menu.wallet': 'Кошелек',
  'landing.startTrading': 'Начать торговлю',
  'landing.trust.activeAddress': 'Активные кошельки',
  'landing.trust.activeAddress.desc':
    'Инфраструктуре и торговой системе Binance DEX доверяет большее число людей, чем любым другим кошельковым решениям.',
  'landing.trust.pairs': 'Пары',
  'landing.trust.pairs.desc':
    'Binance DEX дает вам больше возможностей и гибкости для торговли, с добавлением нововведений каждую неделю.',
  'landing.trust.rank': 'Ранг',
  'landing.trust.rank.desc':
    'Binance DEX - децентрализованная криптовалютная биржа №1 по объему торгов на Coinmarketcap.',
  'landing.trust.title': 'Почему люди доверяют нам',
  'landing.why.competitive': 'Конкурентоспособно',
  'landing.why.competitive.desc':
    'При использовании BNB для оплаты торговых сборов комиссия составляет всего 0,04%. Это почти половина от комиссий на Binance.com, ведущей в мире биржи по торговым сборам.',
  'landing.why.fast': 'Быстро',
  'landing.why.fast.desc':
    'Блоки генерируются каждую секунду, и ожидание подтверждения сделки в блокчейне осталось в прошлом. Воспользуйтесь всеми преимуществами DEX без недостатков.',
  'landing.why.secure': 'Надежно',
  'landing.why.secure.desc':
    'Binance DEX выводит безопасность на совершенно новый уровень. P2P-переводы и торговые сделки означают практически нулевую подверженность угрозам для безопасности.',
  'landing.why.title': 'Почему Binance DEX',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': 'У Вас нет ',
  'openOrders.areYourTrue': 'Вы уверены, что хотите',
  'openOrders.cancel': 'отменить',
  'openOrders.cancel all': 'отменить все',
  'openOrders.cancel buy': 'отменить покупку',
  'openOrders.cancel sell': 'отменить продажу',
  'openOrders.cancelAll': 'Отменить все',
  'openOrders.cancelBuy': 'Отменить покупку',
  'openOrders.cancelOrder': 'Отменить ордер',
  'openOrders.cancelOrders': 'Отменить ордера',
  'openOrders.cancelPartialSuccess': 'Отмена успешна частично',
  'openOrders.cancelSell': 'Отменить продажу',
  'openOrders.cancelSuccess': 'Отменено успешно',
  'openOrders.keepOrder': 'Сохранять ордер',
  'openOrders.keepOrders': 'Сохранять ордера',
  'openOrders.noBuyOpenOrders': 'нет открытых ордеров на покупку',
  'openOrders.noOpenOrders': 'нет открытых ордеров',
  'openOrders.noSellOpenOrders': 'нет открытых ордеров на продажу',
  'openOrders.title': 'Открытые ордера',
  'orderForm.amount': 'Количество',
  'orderForm.avb': 'Доступно',
  'orderForm.buy': 'Купить',
  'orderForm.equivalent': 'Эквивалент',
  'orderForm.price': 'Цена',
  'orderForm.sell': 'Продать',
  'orderForm.total': 'Всего',
  'orderHistory.openHistory': 'история ордеров',
  'orderHistory.title': 'История ордеров',
  'orderHistory.tradeId': 'ID сделки',
  'orderHistory.tradingPrice': 'Торговая цена',
  'orderHistory.tradingTotal': 'Торговая сумма',
  'privateKeyModal.backupText':
    'Сделайте резервную копию представленного ниже текста на бумаге и храните данную копию в секретном и в безопасном месте.',
  'privateKeyModal.title': 'Ваш приватный ключ',
  'testnet.binanceChainExplorerGuide': 'Руководство для Binance Chain Explorer',
  'testnet.fastAndSecureDesc': 'Быстрый и безопасный децентрализованный обмен цифровыми активами',
  'testnet.fundingYourTestnetAccount': 'Пополнение вашего Testnet-аккаунта',
  'testnet.howToAccessYourWallet': 'Как получить доступ к вашему кошельку',
  'testnet.howToCreateAWallet': 'Как создать кошелек',
  'testnet.interfaceGuide': 'Руководство по использованию',
  'testnet.thingsToAvoid': 'Вещи, которые следует избегать',
  'testnet.title': 'Децентрализованная биржа Binance (TESTNET)',
  'token.issueModal.mintable': 'Доступные для создания',
  'token.issueModal.name': 'Название токена',
  'token.issueModal.nameErrMsg': 'название токена ограничено 32 символами',
  'token.issueModal.symbol': 'Символ',
  'token.issueModal.symbolErrMsg':
    'символ должен быть буквенно-цифровым, длина не должна превышать 3~8',
  'token.issueModal.title': 'Создание токена',
  'token.issueModal.totalSupply': 'Общее предложение',
  'token.issueModal.totalSupplyErrMsg': 'недопустимое количество предложения',
  'token.listModal.address': 'Адрес',
  'token.listModal.confirm': 'Подтвердить',
  'token.listModal.initPrice': 'Начальная цена',
  'token.listModal.proposalId': 'ID Предложения',
  'token.listModal.quoteAsset': 'Котировочный актив',
  'token.listModal.title': 'Листинг токена',
  'token.listModal.tokenName': 'Название токена',
  'token.main.burn': 'Сжигание',
  'token.main.freeze': 'Заморозить',
  'token.main.issueToken': 'Создание токена',
  'token.main.list': 'Листинг',
  'token.main.listSuccessmsg': 'Успешный листинг',
  'token.main.mint': 'Создать',
  'token.main.proposal': 'Предложение',
  'token.main.submitListFirst': 'Для начала, пожалуйста, отправьте заявку для листинга',
  'token.main.submitSuccessmsg': 'предложение на листинг успешно отправлено',
  'token.main.title': 'Мой список токенов',
  'token.main.unfreeze': 'Разморозить',
  'token.proposalModal.address': 'Адрес',
  'token.proposalModal.baseAsset': 'Базовый актив',
  'token.proposalModal.desc': 'Описание',
  'token.proposalModal.expireTime': 'Время истечения',
  'token.proposalModal.hours': 'Часы',
  'token.proposalModal.initDeposit': 'Начальный депозит',
  'token.proposalModal.initPrice': 'Начальная цена',
  'token.proposalModal.initPriceErr': 'Начальная цена не должна быть нулевой',
  'token.proposalModal.initPriceErr2': 'начальная цена должна быть больше 0',
  'token.proposalModal.quoteAsset': 'Котировочный актив',
  'token.proposalModal.title': 'Заявка для листинга',
  'token.proposalModal.titleErr': 'Название для заявки не должно быть пустым',
  'token.proposalModal.titleErr2':
    'Название для предложения длиннее максимально возможной длины в 128',
  'token.proposalModal.votingPeriod': 'Период голосования',
  'token.table.col.mintable': 'Доступные для создания',
  'token.table.col.name': 'Название',
  'token.table.col.symbol': 'Символ',
  'token.table.col.totalSupply': 'Общее предложение',
  'token.tokenModal.address': 'Адрес',
  'token.tokenModal.amount': 'Сумма',
  'token.tokenModal.available': 'Доступно',
  'token.tokenModal.burnTitle': 'Сжигание токенов',
  'token.tokenModal.confirm': 'Подтвердить',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': 'Замораживание токенов',
  'token.tokenModal.mintTitle': 'Создание токенов',
  'token.tokenModal.name': 'Название',
  'token.tokenModal.unfreezeTitle': 'Разморозить токен',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': 'история сделок',
  'transaction.here': 'здесь',
  'transaction.notes':
    'Не все транзакции отображены ниже. Для получения полной истории, пожалуйста, обратитесь',
  'txHistory.here': 'здесь',
  'txHistory.notEveryTransactionIsIncludedBelow':
    'Не все транзакции отображены ниже. Для получения полной истории, пожалуйста, обратитесь сюда.',
  'txHistory.title': 'История транзакций',
  'unlock.connectAddress.enterYourAddress': 'Введите свой адрес',
  'unlock.connectAddress.invalidAddress': 'Неверный адрес',
  'unlock.connectAddress.viewOnlyMode': 'Введите адрес для режима «только просмотр»',
  'unlock.createNewWallet': 'Создать новый кошелек',
  'unlock.google.chooseWallet': 'Выберите из доступных кошельков:',
  'unlock.google.logIn': 'Войти',
  'unlock.google.notLoggedIn': 'Вы не вошли в свой аккаунт Google',
  'unlock.google.signedInAs': 'Вы вошли как',
  'unlock.googledrive.editWallet': 'Изменить информацию о кошельке',
  'unlock.googledrive.wallets': 'Выберите из следующих кошельков, чтобы продолжить:',
  'unlock.index.selectUnlockType': 'Выберите, каким образом вы хотели бы разблокировать',
  'unlock.index.title': 'Разблокировать кошелек',
  'unlock.keystore.enterYourWalletPass': 'Введите пароль вашего кошелька',
  'unlock.keystore.paste': 'Или вставьте содержимое файла Keystore',
  'unlock.keystore.select': 'Подключите зашифрованный файл кошелька и введите свой пароль',
  'unlock.keystore.upload': 'Загрузить Keystore файл',
  'unlock.ledger.appInstallation': 'Установка приложения',
  'unlock.ledger.binanceChainReady': 'Binance Chain Ready',
  'unlock.ledger.connectToLedger': 'Подключиться к Ledger',
  'unlock.ledger.enterPINCode': 'Введите PIN-код',
  'unlock.ledger.getTheApp': 'Получить приложение',
  'unlock.ledger.havingConnectionIssues': 'Имеются трудности с подключением?',
  'unlock.ledger.mustBeOnScreen': 'должно быть на экране',
  'unlock.ledger.openBinanceChain': 'Открыть Binance Chain',
  'unlock.ledger.text':
    'Подключите свой аппаратный кошелек, следуя представленным инструкциям на экране',
  'unlock.ledger.title': 'Разблокировать с помощью устройства Ledger',
  'unlock.ledger.usageInstructions': 'Инструкции по использованию',
  'unlock.mnemonic.pleaseEnterYourPhrase': 'Пожалуйста, введите вашу фразу из 24-х слов',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': 'Пожалуйста, отделите каждое слово пробелом.',
  'unlock.mnemonic.warning.desc1':
    'Данная опция восстанавливает утерянный файл Keystore или пароль,',
  'unlock.mnemonic.warning.desc2': 'или импортируйте сид-фразу из другого приложения кошелька.',
  'unlock.mnemonic.warning.desc3':
    'Предупреждение! Опасно вводить сид-фразу или приватный ключ на любых сторонних сайтах. Если в вашем браузере установлены вредоносные расширения или вы случайно зашли на фишинговый веб-сайт, ваши активы могут быть украдены.',
  'unlock.privateKey.enterYourPrivateKey': 'Введите свой приватный ключ (в формате hex)',
  'unlock.privateKey.invalid':
    'Введенный вами приватных ключ имеет неверный формат и недействителен. Пожалуйста, попробуйте еще раз.',
  'unlock.privateKey.passwordInvalid':
    'Этот пароль недействителен. Пожалуйста, попробуйте еще раз.',
  'unlock.privateKey.warning': 'Для восстановления утерянного файла Keystore или пароля',
  'unlock.privateKey.warningQuestion':
    'Ввод вашего приватного ключа на любых сторонних сайтах очень опасен. Если в вашем браузере установлены вредоносные расширения или вы случайно зашли на фишинговый веб-сайт, ваши активы могут быть украдены.',
  'unlock.recover.content':
    'Восстановление доступа к кошельку с помощью специальной фразы, сохраненной во время создания кошелька',
  'unlock.recover.download.button': 'Загрузить',
  'unlock.recover.downloadTitle': 'Загрузить файл Keystore',
  'unlock.recover.password.placeholder': 'Введите надежный пароль',
  'unlock.recover.submit': 'Отправить',
  'unlock.recover.title': 'Восстановить файл Keystore',
  'unlock.recover.understand.continue': 'Восстановить файл Keystore',
  'unlock.recover.word.placeholder': 'Поиск',
  'unlock.recover.wordlist.reset': 'Сбросить',
  'unlock.recover.wordlistTitle': 'Пожалуйста, выберите свою мнемоническую фразу из списка слева',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': 'Пароль временной сессии',
  'unlock.thisIsNotAValidWalletFile': 'Это неверный файл кошелька',
  'unlock.trezor.connectToTrezor': 'Подключиться к Trezor',
  'unlock.trezor.firmwareNotice':
    'Примечание: Чтобы использовать ваше устройство с Binance Chain, пожалуйста, убедитесь, что у вас установлено последнее программное обеспечение Trezor.',
  'unlock.trezor.notOnTestNet':
    'Примечание: для устройств Trezor требуется использовать Chrome или Firefox ',
  'unlock.trezor.title': 'Разблокировать с помощью устройства Trezor',
  'unlock.unlockWalletNow': 'Разблокировать кошелек сейчас',
  'unlock.walletConnect.notes':
    'Примечание: Trust Wallet и CoolWallet не поддерживают Testnet Binance Chain.',
  'unlock.walletConnect.recommendedWallet': 'Поддерживаемые приложения включают',
  'unlock.walletConnet.getTrustWallet': 'Скачать Trust Wallet',
  'unlock.walletConnet.qrCodeDesc1': 'Получить QR-код для WalletConnect',
  'unlock.walletConnet.qrCodeDesc2':
    'У вас еще нет приложения, которое поддерживает WalletConnect?',
  'unlock.walletConnet.showWalletQrCode':
    'Подключите свой мобильный кошелек, используя QR-код на данном экране',
  'unlock.walletConnet.title': 'Рекомендовано',
  'walletConnect.clickHereToUnlock': 'Нажмите здесь, чтобы разблокировать другой кошелек',
  'walletConnect.error': 'Ошибка WalletConnect',
  'walletConnect.errorOccur': 'Произошла ошибка WalletConnect',
  'walletConnect.pleaseEnsureOpenWorking':
    'Пожалуйста, убедитесь, что приложение открыто и работает.',
  'walletConnect.pleaseUseAWalletConnect':
    'Пожалуйста, используйте приложение, которое поддерживает WalletConnect, чтобы отсканировать QR-код, представленный выше',
  'walletConnect.qrCode': 'QR-код для WalletConnect',
  'walletConnect.readyToConfirm': 'Пожалуйста, подтвердите',
  'walletConnect.readyToConfirmBody': 'Пожалуйста, подтвердите транзакцию в приложении кошелька.',
  'walletconnect.notifycation.connectAgain': 'Подключить снова',
  'walletconnect.notifycation.disconnectMessage': ' Отключено от мобильного кошелька...',
  'walletconnect.notifycation.hide': 'Скрыть',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
